var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.91076 16.0059C6.58533 15.6805 6.58533 15.1528 6.91076 14.8274L12.1548 9.58333L6.91076 4.33926C6.58533 4.01382 6.58533 3.48618 6.91076 3.16074C7.2362 2.83531 7.76384 2.83531 8.08928 3.16074L13.9226 8.99408C14.248 9.31951 14.248 9.84715 13.9226 10.1726L8.08928 16.0059C7.76384 16.3314 7.2362 16.3314 6.91076 16.0059Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightWhite);
export default __webpack_public_path__ + "static/media/arrow-right-white.3c14ed3ca5dd06e9ebc353a3c98c1632.svg";
export { ForwardRef as ReactComponent };